<template>
  <Modal content-class="fund-modal">
    <template #activator="{ onClick }">
      <CardFund
        button
        :fund="fundBasicData"
        @click="
          () => {
            onClick();
            handleOpen();
          }
        "
      />
    </template>
    <template #content="{ close }">
      <div class="fund-modal__inner">
        <div v-if="fundBasicData.avatar" class="fund-modal__logo">
          <img :src="fundBasicData.avatar?.imagePart?.preview" />
        </div>
        <div class="fund-modal__head">
          <div class="fund-modal__title">
            {{ fundBasicData.name }}
          </div>
        </div>
        <Loader v-if="isLoading" class="fund-modal__loader" />
        <div v-else class="fund-modal__description" v-html="fundDescription" />
        <div class="fund-modal__actions">
          <UiButton class="fund-modal__button" color="secondary" @click="close">
            {{ $t('button.good') }}
          </UiButton>
        </div>
      </div>
    </template>
  </Modal>
</template>
<script setup>
import useLanguageStore from '~/store/language';

const { $useApi } = useNuxtApp();

const { fundId } = defineProps({
  fundId: {
    type: [String, Number],
    required: true,
  },

  fundBasicData: {
    type: Object,
    default: () => ({}),
  },
});

const fundFullData = ref(null);
const isLoading = ref(false);
const activeLanguage = computed(() => useLanguageStore().getActiveLanguageCode);

const fundDescription = computed(() => {
  const description = fundFullData?.value?.description || '';
  return description.replace(/<video[\s\S]*?<\/video>/gi, '');
});

watch(activeLanguage, async () => {
  fundFullData.value = null;
});

function handleOpen() {
  if (fundFullData.value) return;
  getFundData();
}

async function getFundData() {
  isLoading.value = true;
  const headers = useCustomRequestHeaders();

  try {
    fundFullData.value = await $fetch($useApi.fund.getFund(fundId), {
      headers,
    });
  } catch (error) {
    console.error('Error fetching fund:', error);
  } finally {
    isLoading.value = false;
  }
}
</script>

<style lang="scss">
@use '@styles/components/pages/project/fundModal.scss' as *;
</style>
